const opts = {
  arrows: true,
  dots: true,
  infinite: true,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  swipeToSlide: true,
};

const photosOpts = {
  ...opts,
  lazyLoad: 'progressive',
};

const feedbackOpts = {
  ...opts,
  pauseOnHover: true,
  autoplaySpeed: 4000,
};

const documentsOpts = {
  ...opts,
  lazyLoad: 'progressive',
  initialSlide: 1,
};


export { photosOpts, feedbackOpts, documentsOpts };


// WEBPACK FOOTER //
// ./src/components/About/SliderConfig.js